export const defaultPrompts = [
    {
      icon: 'info',
      title: 'PROMPTS.PRODUCT_INFORMATION.TITLE',
      prompt: 'PROMPTS.PRODUCT_INFORMATION.PROMPT'
    },
    {
      icon: 'cart',
      title: 'PROMPTS.ORDER_INFORMATION.TITLE',
      prompt: 'PROMPTS.ORDER_INFORMATION.PROMPT'
    },
    {
      icon: 'dollar',
      title: 'PROMPTS.PRICING_AVAILABILITY.TITLE',
      prompt: 'PROMPTS.PRICING_AVAILABILITY.PROMPT'
    },
    {
      icon: 'questionMark',
      title: 'PROMPTS.SUPPORT_OPTIONS.TITLE',
      prompt: 'PROMPTS.SUPPORT_OPTIONS.PROMPT'
    },
];